import { P2GDate, P2GText } from '@parcel2go/core-ui';

import { CollectionDateApiModel } from '~/lib/api/smartsend/types';
import DropList from '../../DropList';
import { toDisplayCurrency } from '~/components/currency/toDisplayCurrency';

interface props {
  dates: CollectionDateApiModel[];
  selected?: Date;
  setDate: (d: Date) => void;
  variant?: 'body2';
  size: 'small' | 'medium' | 'large';
  limit: number;
  textAlign?: 'left' | 'center' | 'right';
}

export default function ItemCollectionDateView(props: props) {
  if (!props.selected || !props.dates || !props.dates.length) {
    return null;
  }

  return (
    <DropList
      textAlign={props.textAlign}
      selected={[props.selected.toDateString()]}
      items={props.dates.slice(0, props.limit).map((x) => {
        const d = new Date(x.Date);
        return {
          value: d.toDateString(),
          text: (
            <>
              <P2GDate variant={props.variant} size={props.size} date={d} />
              {x.Breakdown?.['Net'] > 0 && (
                <P2GText variant={props.variant} ml={1}>
                  + {toDisplayCurrency(null, x.Breakdown['Net'])}
                </P2GText>
              )}
            </>
          )
        };
      })}
      onSelect={(x) => props.setDate(new Date(x))}
    />
  );
}
